/**
 * @deprecated Используйте SmallCard из '@/shared/components/card' вместо этого компонента.
 * @see SmallCardV2
 */
export { SmallCard } from './ui/SmallCard';

/**
 * @deprecated Используйте SmallCardV2Props из '@/shared/components/card' вместо этого типа.
 * @see SmallCardV2Props
 */
export type { SmallCardProps } from './ui/types';
